<div class="page pg_member_custom" *ngIf="sectionContentDivImage !== null && sectionContentDivImage!==''">
    <section>
        <div class="custom-box1">
            <div class="row">
                <div class="col-md-12 col-lg-12  chairmain-description ">

                    <div style="width: 20%;" class=" my-2 float-start chairman_picture-full-width-container">
                        <div class="chairman_picture justify-content-center">
                            <div class="">
                                <cbic-inner-component-image [inputDataImage]="sectionContentDivImage">
                                </cbic-inner-component-image>
                            </div>

                            <span class="chairman-name">
                                <cbic-static-text [textEn]="chairmanProfile!.titleEn"
                                    [textHi]="chairmanProfile!.titleHi"></cbic-static-text>
                            </span>
                            <br><span class="chairman-des">Chairman, CBIC</span>
                        </div>
                    </div>
                    <div style="width:80%;"
                        class="col-md-10 chairman_profile text_purple px-4 py-2 card scrollbar-primary  borderNone">
                        <cbic-inner-component [inputData]="sectionContentDiv"></cbic-inner-component>
                    </div>

                    <hr />
                    <div class="full-width">
                        <div class="float-start full-width ">
                            <ul class="tabs">
                                <li>
                                    <input id="tab1" type="radio" name="tabs" checked />
                                    <label for="tab1">Past Chairmen</label>
                                    <div id="tab-panel1" class="tab-panel">

                                        <div class="row chairmanData ">

                                            <div class="">
                                                <cbic-inner-component [inputData]="pastChairmenSectionContent">
                                                </cbic-inner-component>
                                            </div>

                                        </div>

                                    </div>
                                </li>
                                <li>
                                    
                                    <input id="tab2" type="radio" name="tabs" />
                                    <label for="tab2">Newsletters</label>
                                    <div id="tab-panel2" class="tab-panel">
                                        
                                        <cbic-newsletter></cbic-newsletter>
                                    </div>
                                </li>

                            </ul>
                        </div>
                    </div>
                </div>

            </div>


        </div>
    </section>



</div>